/**
 * Tiny helper that fetches /gigs/categories/ with a 10-minute sessionStorage cache.
 * Use this instead of API.get('/gigs/categories/') for instant navigation.
 */
import API from '../api';

const KEY = 'lc_categories_cache_v1';
const TTL = 10 * 60 * 1000;

let inflight = null;

export function getCategoriesCached() {
  // Try sessionStorage first
  try {
    const cached = sessionStorage.getItem(KEY);
    if (cached) {
      const { data, ts } = JSON.parse(cached);
      if (Date.now() - ts < TTL && Array.isArray(data)) {
        return Promise.resolve({ data });
      }
    }
  } catch (e) {}

  // Coalesce concurrent calls
  if (inflight) return inflight;

  inflight = API.get('/gigs/categories/')
    .then(res => {
      const data = res.data?.results || res.data || [];
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ data, ts: Date.now() }));
      } catch (e) {}
      return { data };
    })
    .finally(() => { inflight = null; });
  return inflight;
}
